//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "stafftraininginfo",
  props: {
    //业务数据
    record: {
      type: Object,
      default: () => ({})
    },
    //流程数据
    process: {
      type: Object,
      default: () => ({})
    },
    //规则绑定
    rules: {
      type: Object,
      default: () => ({})
    },
    //自定义的参数
    config: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {}
  },
  methods: {
    /**
     * 初始化下拉框
     */
    initSelect() {},
    /**
     * 校验培训日期选项
     */
    async checktratime(){
        var len = this.record.trainingrow.length;
        var flag = true;
        for(let i = 0 ; i < len; i++ ){
          if(this.record.trainingrow[i].trabegintime !=null && this.record.trainingrow[i].trabegintime != ''
            && this.record.trainingrow[i].traendtime !=null && this.record.trainingrow[i].traendtime != ''){
                let begintime = this.forMatDate(this.record.trainingrow[i].trabegintime);
                let endtime = this.forMatDate(this.record.trainingrow[i].traendtime);  
                if (begintime > endtime) {
                  flag = false
                }
          }
        }
        return flag;
    }
  },
  created() {
    this.initSelect();
  },
}




// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/stafftraininginfo.vue